/**
 * Handelswährung und Umrechnungskurs — EINE Quelle.
 *
 * Diese Funktionen standen bis zum 10.08.2026 zeichengleich in zwei Dateien
 * (`src/lib/trade-planning/generate.ts` und `src/lib/v51/generate-plan-v51.ts`).
 * Anlass des Zusammenlegens war der „Gekauft"-Knopf, der sie als dritter
 * Aufrufer gebraucht hätte — und drei Kopien einer Umrechnung sind genau die
 * Sorte paralleler Wahrheit, die in diesem Projekt schon genug Schaden
 * angerichtet hat. Verhalten unverändert übernommen, kein Zeichen geändert.
 *
 * EHRLICHKEIT ZU DEN KURSEN: Das sind FESTE Werte, kein Live-Kurs. Für die
 * Positionsgrößen-Rechnung ist das vertretbar — ein paar Prozent Abweichung
 * beim EUR/USD verschieben die Stückzahl kaum, und die Alternative wäre eine
 * weitere Abhängigkeit für eine Zahl, die der Nutzer ohnehin überschreibt.
 * Für eine Steuer- oder Performancerechnung wäre es NICHT vertretbar.
 */

const STATISCHE_KURSE: Record<string, number> = {
  'USD/USD': 1,
  'EUR/EUR': 1,
  'USD/EUR': 0.92,
  'EUR/USD': 1 / 0.92,
};

/** In welcher Währung notiert dieses Symbol? */
export function deriveTradeCurrency(
  symbol: string,
  hint: string | null | undefined
): string {
  if (hint && hint.length === 3) return hint.toUpperCase();
  const upper = symbol.toUpperCase();
  if (upper.endsWith(':XETRA') || upper.endsWith('.DE')) return 'EUR';
  // BTC/USD, ETH/USD … haben USD als Quote-Currency
  // US-Listings (AAPL, MSFT, …) ebenfalls USD
  return 'USD';
}

/** Umrechnungsfaktor von Handels- in Kontowährung. Unbekannt → 1. */
export function fxRate(fromCcy: string, toCcy: string): number {
  if (fromCcy === toCcy) return 1;
  return STATISCHE_KURSE[`${fromCcy}/${toCcy}`] ?? 1;
}
